import { createFileRoute } from "@tanstack/react-router";
import { EmentaLP } from "@/components/ementalp/EmentaLP";

const TITLE = "Ementa da Pós em Ortopedia e Traumatologia | FEO";
const DESC =
  "Baixe em PDF a ementa completa da pós-graduação em Fisioterapia em Ortopedia e Traumatologia da FEO: 12 módulos, 360h, corpo docente e formato das aulas.";
const URL = "https://fisioemortopedia.com.br/ementa-orto";

export const Route = createFileRoute("/ementa-orto")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:image", content: "https://storage.googleapis.com/gpt-engineer-file-uploads/uJh6Ec5dB7QIUilgPzSo9fT36WL2/social-images/social-1783178899843-ChatGPT_Image_4_de_jul._de_2026,_12_28_08.webp" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: "https://storage.googleapis.com/gpt-engineer-file-uploads/uJh6Ec5dB7QIUilgPzSo9fT36WL2/social-images/social-1783178899843-ChatGPT_Image_4_de_jul._de_2026,_12_28_08.webp" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Course",
          name: "Pós-graduação em Fisioterapia em Ortopedia e Traumatologia",
          description: DESC,
          url: URL,
          courseMode: "online",
          educationalCredentialAwarded: "Especialização lato sensu (MEC)",
          provider: {
            "@type": "Organization",
            name: "FEO · Fisio em Ortopedia",
            url: "https://fisioemortopedia.com.br",
          },
        }),
      },
    ],
  }),
  component: EmentaOrtoPage,
});

function EmentaOrtoPage() {
  return <EmentaLP slug="orto" />;
}
